<div class="loader-container" *ngIf="showLoader">
  <mat-spinner class="center"></mat-spinner>
</div>

